import { useEffect } from "react";
import { X } from 'lucide-react';

const Modal = ({ title, body, footerButton, onClose }) => {
  
  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    return () => {
      document.body.style.overflow = "auto";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, []);

  return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div>
            <div className="modal-header">
              <div className="modal-header-title">{title}</div>
              <button className="close-icon" onClick={onClose} style={{display: "flex", alignItems: "center"}}>
                <X size={30} />
              </button>
            </div>
            <div className="modal-body">{body}</div>
          </div>
          <div className="modal-footer">{footerButton}</div>
        </div>
      </div>
    );
  };

export default Modal;